import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoginService } from 'src/app/login.service';
import { TranslatorService } from 'src/app/translator.service';
import { AvatarselectComponent } from '../avatarselect/avatarselect.component';

@Component({
  selector: 'app-addkid',
  templateUrl: './addkid.component.html',
  styleUrls: ['./addkid.component.scss'],
})
export class AddkidComponent implements OnInit {

  public arrIndex = [];
  public currentClassSelected = -1;
  public buttonStates = ['success', 'success', 'success', 'success', 'success',
    'success', 'success', 'success', 'success', 'success', 'success', 'success'];
  public idx = 0;
  public placeholdername = '';
  public kidname = '';
  public avatarImage = './../../../../assets/avatars/0.png';
  public selectedAvatar = 0;
  constructor(public translatorService: TranslatorService, public modalCtrl: ModalController, public loginService: LoginService) { }

  ngOnInit() {
    this.placeholdername = this.translatorService.translate('idx', '*Introduceti numele elevului');
  }
  public changeClass(index) {
    this.buttonStates[this.currentClassSelected] = 'success';
    this.currentClassSelected = index;
    this.buttonStates[this.currentClassSelected] = 'warning';

  }

  changeAvatar() {
    this.modalCtrl.create({
      component: AvatarselectComponent,
      cssClass: this.loginService.isDesktop ? 'modal-halfscreen': 'modal-fullscreen',
      componentProps: {
      },
      backdropDismiss: false
    }).then(modalEl => {
      modalEl.present();
      modalEl.onDidDismiss().then(result => {
        this.selectedAvatar = +result.data.idx;
        this.avatarImage = './../../../../assets/avatars/' + this.selectedAvatar + '.png';
      });
    });
  }
  confirmAccount() {
    if (this.currentClassSelected === -1 || this.kidname.length === 0) {
      alert(this.translatorService.translate('idx', '*Completati toate informatiile!'));
      return;
    }
      this.modalCtrl.dismiss({ status: true, avataridx: this.selectedAvatar, kidname: this.kidname, class: this.currentClassSelected }, '');
  }
  cancelAccount() {
    this.modalCtrl.dismiss({ status: false }, '');
  }

}
